var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "title-table" }, [
        _vm._v("Deseja adicionar tabela de frete?")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flat-switch" },
        [
          _c("sc-switch", {
            staticClass: "switch-add",
            on: { input: _vm.addFreightTable }
          }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.includeFreightTable ? "Sim" : "Não") +
              "\n  "
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.includeFreightTable
        ? _c("sc-freight-form", {
            attrs: { checkFields: _vm.checkFields },
            model: {
              value: _vm.lpData,
              callback: function($$v) {
                _vm.lpData = $$v
              },
              expression: "lpData"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("help-button")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edb38394", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edb38394","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/ScFreightTable.vue
// module id = null
// module chunks = 